import { makeStyles } from '@material-ui/core';

import { tokens, withAlpha } from '../../core/theming/tokens';

export let useStyles = makeStyles((theme) => ({
  main: {
    display: 'flex',
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    backgroundColor: tokens.bg,
    // Specular sutil: un velo de luz fria arriba, austero, sin gradientes ruidosos.
    backgroundImage: `radial-gradient(120% 80% at 50% -10%, ${withAlpha(
      tokens.accent,
      0.08
    )} 0%, rgba(0,0,0,0) 55%)`,
  },
  card: {
    width: '100%',
    maxWidth: 384,
    padding: theme.spacing(5, 4, 4),
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: tokens.surface,
    border: `1px solid ${tokens.line}`,
    borderRadius: 16,
    boxShadow: '0 24px 64px -24px rgba(28,29,33,0.16)',
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: theme.spacing(3),
  },
  eyebrow: {
    color: tokens.faint,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 2.4,
    textTransform: 'uppercase',
    marginTop: theme.spacing(3),
  },
  title: {
    color: tokens.text,
    fontWeight: 500,
    marginTop: theme.spacing(0.5),
  },
  content: {
    paddingBottom: theme.spacing(1),
  },
  input: {
    marginTop: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: 0,
    marginTop: theme.spacing(1),
  },
  submitButton: {
    marginTop: theme.spacing(1.5),
    height: 46,
  },
  toggleButton: {
    marginTop: theme.spacing(1),
  },
  // ── 2FA (Google Authenticator) ──────────────────────────────────────────
  helpText: {
    color: tokens.textDim,
    fontSize: 13,
    lineHeight: 1.5,
    marginTop: theme.spacing(1),
  },
  qrWrap: {
    // El QR necesita fondo claro para escanear, sin importar el tema.
    display: 'grid',
    placeItems: 'center',
    width: 216,
    height: 216,
    margin: theme.spacing(2.5, 'auto', 1),
    padding: theme.spacing(1),
    backgroundColor: '#ffffff',
    borderRadius: 12,
    border: `1px solid ${tokens.line}`,
  },
  qrImg: {
    display: 'block',
    width: 200,
    height: 200,
  },
  codesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  codeItem: {
    fontFamily: "'SFMono-Regular', 'Menlo', 'Consolas', 'Liberation Mono', monospace",
    fontSize: 14,
    letterSpacing: 1,
    textAlign: 'center',
    color: tokens.text,
    backgroundColor: tokens.bg,
    border: `1px solid ${tokens.line}`,
    borderRadius: 8,
    padding: theme.spacing(0.75, 0),
  },
  savedCheck: {
    marginTop: theme.spacing(2),
    color: tokens.textDim,
  },
}));
